import React, { useState } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ProgressButton from "react-progress-button";
import styles from "../InvoiceDetails/InvoiceDetails.module.css";
import { saveAs } from "file-saver";
import { API } from "../../api";
import EmailModal from "../Invoices/EmailModal";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReportPdfGenerator = ({ payments, name, billingCycle }) => {
  const [downloadStatus, setDownloadStatus] = useState(null);
  const [sendStatus, setSendStatus] = useState(null);
  const [open, setOpen] = useState(false);
  const [reciver, setReciver] = useState({
    name: "Manel Mrabet",
    email: "mrabet.manel@gmail.com",
  });

  // create invoice data

  const handleSendMail = (e) => {
    e.preventDefault();
    setSendStatus("loading");
    API.post(`/send-pdf-report`, {
      email: reciver.email,
      data: billingCycle,
    })
      // .then(() => console.log("invoice sent successfully"))
      .then(() => setSendStatus("success"))
      .catch((error) => {
        console.log(error);
        setSendStatus("error");
      });
  };

  const generatePdf = () => {
    setDownloadStatus("loading");
    API.post(`/create-pdf-report`, billingCycle)
      .then(() =>
        API.get(`/fetch-pdf-report`, {
          responseType: "blob",
        })
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });

        saveAs(pdfBlob, "report.pdf");
      })
      .then(() => {
        setDownloadStatus("success");
      });
  };

  return (
    <div className={styles.buttons}>
      <ProgressButton onClick={generatePdf} state={downloadStatus}>
        Download PDF
      </ProgressButton>
      <ProgressButton onClick={() => setOpen(true)} state={sendStatus}>
        Send via email
      </ProgressButton>
      <EmailModal
        open={open}
        setOpen={setOpen}
        handleSendMail={handleSendMail}
        reciver={reciver}
        setReciver={setReciver}
      />
    </div>
  );
};

export default ReportPdfGenerator;
